import { confirm } from '../../store/alerts.js';

const defaultConfirmationOptions = {
  title: "Are you sure?",
  content: "This action cannot be undone.",
  confirmLabel: "Yes, Delete",
  cancelLabel: "Cancel"
};
const withConfirmation = (mutation, baseGetConfirmationOptions) => {
  return {
    ...mutation,
    confirmAndMutateAsync: async (data, getConfirmationOptions) => {
      const options = getConfirmationOptions?.(data) ?? baseGetConfirmationOptions?.(data) ?? defaultConfirmationOptions;
      const confirmed = await confirm(options);
      if (!confirmed) return;
      return mutation.mutateAsync(data);
    },
    confirmAndMutate: (data, options) => {
      const confirmationOptions = options?.getConfirmationOptions?.(data) ?? baseGetConfirmationOptions?.(data) ?? defaultConfirmationOptions;
      confirm(confirmationOptions).then(async (confirmed) => {
        if (!confirmed) {
          options?.onCanceled?.();
          return;
        }
        mutation.mutate(data, options);
        if (options?.onConfirm) {
          await options.onConfirm();
        }
      });
    }
  };
};

export { withConfirmation };
//# sourceMappingURL=withConfirmation.js.map
